import { Component } from 'san';
import { IProjectFilterItem, IProjectFilters } from 'src/models';

export default class ProjectFilter extends Component {
    constructor(options: any) {
        super(options);
    }

    static computed = {
        checkedRoles() {
            const data = this.data.get('projectFilters.role');
            if (!data) {
                return [];
            }
            return _.filter(data.items, { is_checked: true });
        },
        checkedStatuses() {
            const data = this.data.get('projectFilters.status');
            if (!data) {
                return [];
            }
            return _.filter(data.items, { is_checked: true });
        },
        checkedTypes() {
            const data = this.data.get('projectFilters.type');
            if (!data) {
                return [];
            }
            return _.filter(data.items, { is_checked: true });
        },
        checkedLevels() {
            const data = this.data.get('projectFilters.level');
            if (!data) {
                return [];
            }
            return _.filter(data.items, { is_checked: true });
        },
        checkedGroups() {
            const data = this.data.get('projectFilters.group');
            if (!data) {
                return [];
            }
            return _.filter(data.items, { is_checked: true });
        },
        checkedLights() {
            const data = this.data.get('projectFilters.light');
            if (!data) {
                return [];
            }
            return _.filter(data.items, { is_checked: true });
        },
        checkedCategories() {
            const data = this.data.get('projectFilters.category');
            if (!data) {
                return [];
            }
            return _.filter(data.items, { is_checked: true });
        },
        checkedOrganizations() {
            const data = this.data.get('projectFilterOrganization');
            if (!data) {
                return [];
            }
            return _.filter(data.items, { _is_checked: true });
        },
        checkedCreateOrganizations() {
            const data = this.data.get('projectFilterCreateOrganization');
            if (!data) {
                return [];
            }
            return _.filter(data.items, { _is_checked: true });
        }
    }


    initData(): {
        isAll: boolean; // {{}} 显示所有筛选条件。 true: 项目中心项目列表页。 false: 选择项目列表组件CheckProjects
        projectFilters: IProjectFilters;
    } {
        return {
            isAll: false,
            projectFilters: {}
        };
    }

    inited() {
    }

    unCheck(item: IProjectFilterItem, projectFilterKey: string) {
        const dataKey = `projectFilters.${projectFilterKey}.items`;
        const items: IProjectFilterItem[] = this.data.get(dataKey);
        const index: number = _.findIndex(items, { value: item.value });
        items[index].is_checked = false;
        this.dispatch('UI:project-filter-changed', {
            key: projectFilterKey,
            items
        });
    }

    unCheckProjectFilterOrganization() {
        this.dispatch('UI:project-filter-organization-changed', undefined);
    }

    unCheckProjectFilterCreateOrganization() {
        this.dispatch('UI:project-filter-create-organization-changed', undefined);
    }

}